module.exports = __webpack_public_path__ + "img/career-trajectory.8a5d2dd9.jpg";